import PropTypes from 'prop-types';
import { Component } from 'react';
import { player } from 'src/client/player';
import { mintSingleton } from '../../../client/mint';
import isServer from '../../utils/isServer';

export default function withAdScreenRequest(getScreenName) {
  return (BaseComponent) => {
    class WithScreenAdRequest extends Component {
      static propTypes = {
        match: PropTypes.object.isRequired,
      };

      constructor(props) {
        super(props);
        if (!isServer()) {
          this.updateCurrentScreen();
        }
      }

      async updateCurrentScreen() {
        if (!player.isActive) {
          mintSingleton.updateState('currentScreen', getScreenName(this.props));
          return;
        }

        player.setAppSessionData({ currentScreen: getScreenName(this.props) });
      }

      componentDidUpdate(prevProps) {
        if (prevProps.match.params !== this.props.match.params) {
          this.updateCurrentScreen();
        }
      }

      render() {
        return <BaseComponent {...this.props} />;
      }
    }

    return WithScreenAdRequest;
  };
}
